/* Maison Jaspers viewing room: a short show that teaches the visitor to turn the piece, then hands over control. */
(function () {
  var MV_SRC = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@4.1.0/dist/model-viewer.min.js';
  function loadViewer() {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (!loadViewer.p) {
      loadViewer.p = new Promise(function (res, rej) {
        var s = document.createElement('script');
        s.type = 'module'; s.src = MV_SRC; s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      }).then(function () { return customElements.whenDefined('model-viewer'); });
    }
    return loadViewer.p;
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var P = [];
    try { P = JSON.parse(root.querySelector('.mjvr-data').textContent); } catch (e) {}
    if (!P.length) { root.hidden = true; return; }
    var QR = {};
    try { QR = JSON.parse(root.querySelector('.mjvr-qr-data').textContent); } catch (e) {}

    var q = function (c) { return root.querySelector('.mjvr-' + c); };
    var mv = q('mv'), stage = q('stage'), poster = q('poster'), posterImg = q('poster img');
    var strip = q('strip'), hint = q('hint'), load = q('loadbar'), err = q('err');
    var ghost = q('hand'), cap = q('cap'), tip = q('tip'), prog = q('prog div'), showBtn = q('show');
    var roomBtn = q('room'), qrBox = q('qr'), viewBtn = q('view');
    var ua = navigator.userAgent;
    var ios = /iPad|iPhone|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
    var android = /Android/i.test(ua);
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var touch = matchMedia('(pointer: coarse)').matches;
    var KIND = { table: 'Table lamp', wall: 'Wall light', objects: 'Object' };
    var START = { th: 30, ph: 78, r: 105 }, FRONT = '0deg 82deg 112%';
    var list = P.slice(), cur = null, sizeOn = false, raf = 0, dimsCache = {};
    var C = { x: 0, y: 0, z: 0 }, D = { x: 0, y: 0, z: 0 }, loadedId = null, waiters = [];
    var cs = { th: START.th, ph: START.ph, r: START.r, ty: null };
    var showOn = false, started = false, touched = false, userPaused = false, hoverVr = false, wasOn = false;
    var token = 0, resumeT = 0, pieceStart = 0, pieceDur = 1;
    var interacted = false;
    try { interacted = localStorage.getItem('mj-vr-dragged') === '1'; } catch (e) {}
    q('hint-t').textContent = touch ? 'Drag sideways to turn' : 'Drag to turn';

    // ---------- filters, strip, selection ----------
    var counts = { all: P.length, table: 0, wall: 0, objects: 0 };
    P.forEach(function (p) { counts[p.cat] = (counts[p.cat] || 0) + 1; });
    root.querySelectorAll('.mjvr-chip[data-f]').forEach(function (c) {
      var n = counts[c.dataset.f] || 0;
      c.querySelector('b').textContent = n;
      if (!n && c.dataset.f !== 'all') c.hidden = true;
    });
    q('total').textContent = P.length;

    function setImg(img, src, fallback) {
      img.onerror = function () { img.onerror = null; if (fallback) img.src = fallback; };
      img.src = src;
    }
    function buildStrip() {
      strip.textContent = '';
      list.forEach(function (p, i) {
        var b = document.createElement('button');
        b.className = 'mjvr-thumb'; b.type = 'button'; b.setAttribute('role', 'option');
        b.dataset.id = p.id; b.title = p.title;
        var img = document.createElement('img'); img.alt = ''; img.loading = i < 12 ? 'eager' : 'lazy'; img.width = 96; img.height = 96;
        setImg(img, p.thumb, p.fallback);
        var s = document.createElement('span'); s.textContent = p.price;
        var sm = document.createElement('small'); sm.textContent = p.title;
        b.append(img, s, sm);
        b.addEventListener('click', function () { userTakes(); select(p); });
        b.addEventListener('pointerenter', function () { warm(p); });
        strip.appendChild(b);
      });
      q('strip-note').textContent = list.length + (list.length === 1 ? ' piece' : ' pieces') + (list.length > 6 ? ' · scroll for more' : '');
    }
    var warmed = {}, srcTimer = 0, lastSelect = 0;
    function warm(p) {
      if (!p || warmed[p.id] || touch) return;
      var c = navigator.connection; if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
      warmed[p.id] = 1;
      try { fetch(p.glb, { mode: 'cors' }).catch(function () {}); } catch (e) {}
    }

    function configureRoom(p) {
      roomBtn.removeAttribute('rel');
      roomBtn.dataset.mode = 'qr';
      roomBtn.href = '#';
      var arImg = roomBtn.querySelector('img.mjvr-ar-img');
      if (ios && p.usdz) {
        roomBtn.rel = 'ar'; roomBtn.href = p.usdz; roomBtn.dataset.mode = 'ar';
        if (!arImg) { arImg = document.createElement('img'); arImg.className = 'mjvr-ar-img'; arImg.alt = ''; arImg.width = 1; arImg.height = 1; roomBtn.prepend(arImg); }
        arImg.src = p.still;
      } else if (android && p.glb) {
        var sp = new URLSearchParams({ file: new URL(p.glb2 || p.glb, location.href).href, mode: 'ar_preferred', title: p.title, link: new URL(p.url, location.href).href });
        if (p.cat === 'wall') sp.set('enable_vertical_placement', 'true');
        var fallback = new URL(location.href); fallback.searchParams.set('room', p.id);
        roomBtn.href = 'intent://arvr.google.com/scene-viewer/1.2?' + sp + '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=' + encodeURIComponent(fallback.href) + ';end;';
        roomBtn.dataset.mode = 'ar';
      }
      q('room-long').textContent = p.cat === 'wall' ? 'See it on your wall' : 'See it in your room';
      q('room-short').textContent = p.cat === 'wall' ? 'On your wall' : 'In your room';
    }

    function select(p, opts) {
      if (!p) return;
      opts = opts || {};
      cur = p;
      var idx = list.indexOf(p);
      q('count').textContent = (idx + 1) + ' / ' + list.length;
      q('kind').textContent = KIND[p.cat] + (p.meta ? ' · ' + p.meta : '');
      q('title').textContent = p.title;
      q('sub').textContent = p.sub || '';
      q('sub').hidden = !p.sub;
      q('price').textContent = p.price;
      q('sizetext').textContent = dimsCache[p.id] || 'Measuring…';
      viewBtn.href = p.url;
      renderQR(p);
      configureRoom(p);
      strip.querySelectorAll('.mjvr-thumb').forEach(function (t) {
        var on = t.dataset.id === String(p.id); t.setAttribute('aria-current', on ? 'true' : 'false'); t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && !opts.noScroll) {
          var sr = strip.getBoundingClientRect(), tr = t.getBoundingClientRect();
          strip.scrollTo({ left: strip.scrollLeft + (tr.left - sr.left) - (sr.width - tr.width) / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
      setImg(posterImg, p.still, p.fallback);
      poster.classList.remove('is-hidden');
      mv.classList.add('is-hidden');
      err.hidden = true;
      load.style.opacity = '1'; load.style.width = '4%';
      mv.autoRotate = false;
      loadedId = null;
      mv.setAttribute('alt', p.title + ', interactive 3D model');
      clearTimeout(srcTimer);
      var now = Date.now(), rapid = now - lastSelect < 600;
      lastSelect = now;
      if (mv.src && mv.src !== p.glb) mv.src = null;
      srcTimer = setTimeout(function () { if (cur === p) mv.src = p.glb; }, rapid ? 450 : 0);
      if (sizeOn) mv.cameraOrbit = FRONT; else cam(START.th, START.ph, START.r, null);
      mv.cameraTarget = 'auto auto auto';
      mv.fieldOfView = 'auto';
    }

    mv.addEventListener('progress', function (e) {
      var t = (e.detail && e.detail.totalProgress) || 0;
      load.style.width = Math.max(4, t * 100) + '%';
    });
    mv.addEventListener('load', function () {
      if (!cur || mv.src !== cur.glb) return;
      try { mv.resetTurntableRotation(0); } catch (x) {}
      mv.jumpCameraToGoal();
      measure();
      loadedId = cur.id;
      requestAnimationFrame(function () {
        mv.classList.remove('is-hidden');
        poster.classList.add('is-hidden');
        load.style.width = '100%';
        setTimeout(function () { load.style.opacity = '0'; }, 250);
      });
      mv.autoRotate = !showOn && !interacted && !reduce && !sizeOn;
      var w = waiters; waiters = []; w.forEach(function (f) { f(true); });
      if (!started && !touched) kick();
      var i = list.indexOf(cur);
      warm(list[(i + 1) % list.length]);
    });
    mv.addEventListener('error', function () {
      if (!cur || mv.src !== cur.glb) return;
      if (cur.glb2) { cur.glb = cur.glb2; cur.glb2 = ''; mv.src = cur.glb; return; }
      load.style.opacity = '0';
      err.hidden = false;
      var w = waiters; waiters = []; w.forEach(function (f) { f(false); });
    });
    mv.addEventListener('camera-change', function (e) {
      if (e.detail && e.detail.source === 'user-interaction') {
        mv.autoRotate = false;
        if (showOn) stopShow();
        touched = true;
        noteActivity();
        if (!interacted) {
          interacted = true; hint.classList.add('is-gone'); tip.hidden = true;
          try { localStorage.setItem('mj-vr-dragged', '1'); } catch (x) {}
        }
      }
    });

    // ---------- camera ----------
    function cam(th, ph, r, ty) {
      cs.th = th; cs.ph = ph; cs.r = r; cs.ty = ty;
      mv.cameraOrbit = th + 'deg ' + ph + 'deg ' + r + '%';
      if (ty != null) mv.cameraTarget = C.x + 'm ' + ty + 'm ' + C.z + 'm';
    }
    function measure() {
      var d = mv.getDimensions(), c = mv.getBoundingBoxCenter();
      D = { x: d.x, y: d.y, z: d.z }; C = { x: c.x, y: c.y, z: c.z };
      var cm = function (v) { return Math.round(v * 100); };
      var txt = 'H ' + cm(d.y) + ' × W ' + cm(d.x) + ' × D ' + cm(d.z) + ' cm';
      dimsCache[cur.id] = txt;
      q('sizetext').textContent = txt;
      var x0 = c.x - d.x / 2, x1 = c.x + d.x / 2, y0 = c.y - d.y / 2, y1 = c.y + d.y / 2, z = c.z + d.z / 2;
      mv.updateHotspot({ name: 'hotspot-top', position: (x1 + d.x * 0.08) + 'm ' + y1 + 'm ' + z + 'm' });
      mv.updateHotspot({ name: 'hotspot-bottom', position: (x1 + d.x * 0.08) + 'm ' + y0 + 'm ' + z + 'm' });
      mv.updateHotspot({ name: 'hotspot-left', position: x0 + 'm ' + (y0 - d.y * 0.06) + 'm ' + z + 'm' });
      mv.updateHotspot({ name: 'hotspot-right', position: x1 + 'm ' + (y0 - d.y * 0.06) + 'm ' + z + 'm' });
      q('t-h').textContent = cm(d.y) + ' cm';
      q('t-w').textContent = cm(d.x) + ' cm';
    }

    // ---------- the show ----------
    var STOP = {};
    function tween(ms, fn, tk) {
      return new Promise(function (res, rej) {
        var s = performance.now();
        function f(now) {
          if (tk !== token) return rej(STOP);
          var k = Math.min(1, (now - s) / ms);
          fn(k);
          prog.style.width = Math.min(100, (now - pieceStart) / pieceDur * 100) + '%';
          if (k < 1) requestAnimationFrame(f); else res();
        }
        requestAnimationFrame(f);
      });
    }
    function wait(ms, tk) { return tween(ms, function () {}, tk); }
    function waitLoad(tk) {
      if (loadedId === (cur && cur.id)) return Promise.resolve(true);
      return new Promise(function (res, rej) { waiters.push(function (ok) { if (tk === token) res(ok); else rej(STOP); }); });
    }
    var inOut = function (k) { return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; };
    var sine = function (k) { return -(Math.cos(Math.PI * k) - 1) / 2; };
    var lerp = function (a, b, k) { return a + (b - a) * k; };
    function move(to, ms, ez, tk, also) {
      var f = { th: cs.th, ph: cs.ph, r: cs.r, ty: cs.ty == null ? C.y : cs.ty };
      return tween(ms, function (k) {
        var e = ez(k);
        cam(lerp(f.th, to.th == null ? f.th : to.th, e), lerp(f.ph, to.ph == null ? f.ph : to.ph, e), lerp(f.r, to.r == null ? f.r : to.r, e), lerp(f.ty, to.ty == null ? f.ty : to.ty, e));
        if (also) also(k, e);
      }, tk);
    }
    function caption(t) {
      if (!t) { cap.classList.remove('is-on'); return; }
      cap.textContent = t; cap.classList.add('is-on');
    }
    function hand(xp, yp, pressed, alpha) {
      var r = stage.getBoundingClientRect();
      ghost.style.transform = 'translate(' + (r.width * xp - 36) + 'px,' + (r.height * yp - 6) + 'px)';
      ghost.style.opacity = alpha;
      ghost.classList.toggle('is-pressed', !!pressed);
    }
    function demo(tk) {
      caption('Grab it and turn it yourself');
      ghost.hidden = false;
      var th0 = cs.th;
      return tween(450, function (k) { hand(0.38, lerp(0.72, 0.6, sine(k)), false, k); }, tk)
        .then(function () { return tween(260, function (k) { hand(0.38, 0.6, k > 0.3, 1); }, tk); })
        .then(function () { return move({ th: th0 - 110 }, 1500, sine, tk, function (k, e) { hand(lerp(0.38, 0.64, e), 0.6, true, 1); }); })
        .then(function () { return tween(260, function (k) { hand(0.64, 0.6, k < 0.4, 1); }, tk); })
        .then(function () { return tween(450, function (k) { hand(lerp(0.64, 0.7, k), lerp(0.6, 0.7, k), false, 1 - k); }, tk); })
        .then(function () { ghost.hidden = true; caption('Your turn'); return wait(1500, tk); })
        .then(function () { caption(''); });
    }
    function actPiece(tk) {
      return waitLoad(tk).then(function (ok) {
        if (!ok) return wait(1200, tk);
        mv.autoRotate = false;
        mv.interpolationDecay = 35;
        var withDemo = !interacted;
        pieceStart = performance.now();
        pieceDur = 3800 + 800 + (withDemo ? 4400 : 0) + 1500 + 1700 + 1100 + 300;
        caption('Every side, in 3D');
        var th0 = cs.th;
        return move({}, 3800, function (k) { return k; }, tk, function (k) {
          cam(th0 + 360 * sine(k), START.ph - 9 * Math.sin(Math.PI * k), START.r + 6 * Math.sin(Math.PI * k), C.y);
        })
          .then(function () { caption(''); return wait(800, tk); })
          .then(function () { return withDemo ? demo(tk) : null; })
          .then(function () {
            var ty = C.y + D.y * (D.y >= D.x ? 0.22 : 0.06);
            var det = (cur.sub || '');
            if (det.length > 30) det = det.slice(0, 30).replace(/\s+\S*$/, '');
            caption(det ? 'Up close: ' + det : 'Up close');
            return move({ th: cs.th - 25, ph: 70, r: 70, ty: ty }, 1500, inOut, tk);
          })
          .then(function () { return wait(1700, tk); })
          .then(function () { caption(''); return move({ th: cs.th + 25, ph: START.ph, r: START.r, ty: C.y }, 1100, inOut, tk); })
          .then(function () { return wait(300, tk); });
      });
    }
    function runShow(tk) {
      actPiece(tk).then(function () {
        var i = list.indexOf(cur);
        select(list[(i + 1) % list.length], {});
        runShow(tk);
      }, function (e) { if (e !== STOP) throw e; });
    }
    function ui() {
      showBtn.setAttribute('aria-pressed', String(showOn));
      q('show-t').textContent = showOn ? 'Pause show' : 'Play show';
      q('i-pause').style.display = showOn ? '' : 'none';
      q('i-play').style.display = showOn ? 'none' : '';
      stage.classList.toggle('is-show', showOn);
      hint.classList.toggle('is-gone', showOn || interacted);
      if (!showOn) prog.style.width = '0';
    }
    function startShow() {
      if (reduce || !list.length || sizeOn || !cur) return;
      clearTimeout(resumeT);
      showOn = true; started = true; userPaused = false; wasOn = false;
      qrBox.hidden = true; roomBtn.setAttribute('aria-expanded', 'false');
      var tk = ++token;
      ui();
      if (loadedId === cur.id) mv.jumpCameraToGoal();
      runShow(tk);
    }
    function stopShow() {
      if (!showOn) return;
      showOn = false; token++;
      ghost.hidden = true; caption('');
      mv.interpolationDecay = 120;
      ui();
    }
    function userTakes() { touched = true; stopShow(); noteActivity(); }
    function noteActivity() {
      clearTimeout(resumeT);
      if (userPaused || reduce) return;
      resumeT = setTimeout(function tryResume() {
        if (showOn || userPaused) return;
        var idle = visible() >= 0.35 && !hoverVr && !sizeOn && qrBox.hidden && document.visibilityState === 'visible';
        if (idle) startShow(); else resumeT = setTimeout(tryResume, 3000);
      }, 9000);
    }

    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      tip.hidden = true;
      if (e.pointerType === 'mouse' || e.pointerType === 'pen') userTakes();
    });
    strip.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') userTakes(); });
    strip.addEventListener('wheel', function () { userTakes(); }, { passive: true });
    strip.addEventListener('touchmove', function () { if (showOn) userTakes(); }, { passive: true });
    showBtn.addEventListener('click', function () {
      if (showOn) { stopShow(); userPaused = true; clearTimeout(resumeT); }
      else { touched = true; startShow(); }
    });
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || interacted || e.buttons || e.target.closest('button')) { tip.hidden = true; return; }
      var r = stage.getBoundingClientRect();
      tip.hidden = false;
      tip.style.transform = 'translate(' + (e.clientX - r.left + 16) + 'px,' + (e.clientY - r.top + 14) + 'px)';
    });
    stage.addEventListener('pointerleave', function () { tip.hidden = true; });
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hoverVr = true; });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hoverVr = false; });

    // visibility drives the show: the piece turns as you scroll in, the show starts in view and pauses out of view
    function visible() {
      var r = stage.getBoundingClientRect(), vh = innerHeight || document.documentElement.clientHeight;
      if (!r.height) return 0;
      return Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height;
    }
    var scrollRaf = 0;
    function onScroll() {
      scrollRaf = 0;
      var v = visible();
      if (!cur) return;
      if (showOn && v < 0.15) { stopShow(); wasOn = true; return; }
      if (!showOn && wasOn && v >= 0.35 && !userPaused) { startShow(); return; }
      if (!cur || started || touched || reduce || loadedId !== cur.id) return;
      var r = stage.getBoundingClientRect(), vh = innerHeight;
      var pr = Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.85)));
      cam(START.th - 140 + 140 * pr, START.ph - 8 + 8 * pr, START.r, null);
      if (v >= 0.6) startShow();
    }
    function kick() { if (!scrollRaf) scrollRaf = requestAnimationFrame(onScroll); }
    addEventListener('scroll', kick, { passive: true });
    addEventListener('resize', kick);

    // ---------- size overlay ----------
    function drawDims() {
      if (!sizeOn) return;
      var qh = function (n) { var h = mv.queryHotspot(n); return h && h.canvasPosition; };
      var a = qh('hotspot-top'), b = qh('hotspot-bottom'), l = qh('hotspot-left'), r = qh('hotspot-right');
      if (a && b && l && r) {
        var set = function (el, x1, y1, x2, y2) { el.setAttribute('x1', x1); el.setAttribute('y1', y1); el.setAttribute('x2', x2); el.setAttribute('y2', y2); };
        set(q('d-h'), a.x, a.y, b.x, b.y); set(q('d-w'), l.x, l.y, r.x, r.y);
        q('t-h').setAttribute('x', a.x + 8); q('t-h').setAttribute('y', (a.y + b.y) / 2 + 4);
        q('t-w').setAttribute('x', (l.x + r.x) / 2); q('t-w').setAttribute('y', l.y + 18);
      }
      raf = requestAnimationFrame(drawDims);
    }
    q('size').addEventListener('click', function () {
      userTakes();
      sizeOn = !sizeOn;
      this.setAttribute('aria-pressed', String(sizeOn));
      q('dims').hidden = !sizeOn;
      mv.autoRotate = !sizeOn && !reduce && !interacted;
      mv.cameraTarget = 'auto auto auto';
      if (sizeOn) { mv.cameraOrbit = FRONT; drawDims(); } else { cam(START.th, START.ph, START.r, null); cancelAnimationFrame(raf); }
    });

    // ---------- in your room: AR on phones, QR code on computers ----------
    function renderQR(p) {
      var d = QR[p.id], box = q('qr-code');
      if (!d) { box.textContent = ''; return; }
      var bytes = atob(d.bits), path = '';
      for (var j = 0; j < d.n * d.n; j++) if (bytes.charCodeAt(j >> 3) & (1 << (7 - j % 8))) path += 'M' + (j % d.n) + ' ' + Math.floor(j / d.n) + 'h1v1h-1z';
      box.innerHTML = '<svg viewBox="0 0 ' + d.n + ' ' + d.n + '" role="img" aria-label="QR code to open this piece in your room" shape-rendering="crispEdges"><rect width="100%" height="100%" fill="#fff"/><path d="' + path + '" fill="#003B36"/></svg>';
    }
    roomBtn.addEventListener('click', function (e) {
      userTakes();
      if (this.dataset.mode === 'ar') return;
      e.preventDefault();
      var open = qrBox.hidden;
      qrBox.hidden = !open;
      this.setAttribute('aria-expanded', String(open));
    });

    // ---------- navigation ----------
    function step(dl) { if (!list.length) return; var i = list.indexOf(cur); select(list[(i + dl + list.length) % list.length]); }
    q('prev').addEventListener('click', function () { userTakes(); step(-1); });
    q('next').addEventListener('click', function () { userTakes(); step(1); });
    q('dice').addEventListener('click', function () {
      userTakes();
      if (list.length < 2) return;
      var n; do { n = list[Math.floor(Math.random() * list.length)]; } while (n === cur);
      select(n);
    });
    root.addEventListener('keydown', function (e) {
      if (e.target === mv || e.target.closest('model-viewer')) return;
      if (e.key === 'ArrowRight') { userTakes(); step(1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { userTakes(); step(-1); e.preventDefault(); }
    });
    strip.addEventListener('scroll', function () { if (!showOn) noteActivity(); }, { passive: true });
    root.querySelectorAll('.mjvr-chip[data-f]').forEach(function (c) {
      c.addEventListener('click', function () {
        userTakes();
        var f = c.dataset.f;
        root.querySelectorAll('.mjvr-chip[data-f]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
        list = f === 'all' ? P.slice() : P.filter(function (p) { return p.cat === f; });
        buildStrip();
        select(list.indexOf(cur) >= 0 ? cur : list[0]);
      });
    });

    // zoom: buttons, pinch, and ctrl/cmd + wheel; a plain wheel always scrolls the page
    stage.addEventListener('wheel', function (e) { if (!e.ctrlKey && !e.metaKey) e.stopPropagation(); else userTakes(); }, { capture: true, passive: true });
    function zoom(f) {
      userTakes();
      var o = mv.getCameraOrbit();
      var r = Math.min(Math.max(o.radius * f, 0.08), 20);
      mv.cameraOrbit = o.theta + 'rad ' + o.phi + 'rad ' + r + 'm';
      mv.autoRotate = false;
    }
    q('zin').addEventListener('click', function () { zoom(0.82); });
    q('zout').addEventListener('click', function () { zoom(1.22); });

    if (reduce) showBtn.hidden = true;
    if (interacted) hint.classList.add('is-gone');
    buildStrip();
    ui();

    // a QR code or shared link (?room=ID) opens that piece
    var deep = new URLSearchParams(location.search).get('room');
    var first = (deep && P.filter(function (p) { return String(p.id) === deep; })[0]) || list[0];
    if (deep && first !== list[0]) { touched = true; setTimeout(function () { root.scrollIntoView({ block: 'start' }); }, 300); }

    // start loading the viewer when the block gets close to the screen
    function boot() {
      loadViewer().then(function () {
        try { customElements.get('model-viewer').modelCacheSize = 0; } catch (e) {}
        mv.minCameraOrbit = 'auto 25deg 55%';
        mv.maxCameraOrbit = 'auto 100deg 180%';
        select(first, { noScroll: true });
      }, function () { select(first, { noScroll: true }); err.hidden = false; });
    }
    setImg(posterImg, first.still, first.fallback);
    var booted = false;
    function near() {
      if (booted) return;
      var r = root.getBoundingClientRect(), vh = innerHeight || document.documentElement.clientHeight;
      if (r.top < vh * 1.75 && r.bottom > -vh) { booted = true; removeEventListener('scroll', near); boot(); }
    }
    addEventListener('scroll', near, { passive: true });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (en) { return en.isIntersecting; })) { io.disconnect(); near(); }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    }
    near();
  }

  function initAll() { document.querySelectorAll('.mjvr').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
